import { useRealtimeUpdates } from '@/hooks/use-realtime-updates';
import { motion, AnimatePresence } from 'framer-motion';
import { WifiOff, Wifi } from 'lucide-react';

export function ConnectionStatus() {
  const { isConnected, getTimeSinceLastUpdate } = useRealtimeUpdates();

  return (
    <AnimatePresence>
      {!isConnected && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          className="fixed top-4 right-4 z-50 bg-red-500 text-white px-4 py-2 rounded-lg shadow-lg flex items-center gap-2"
        >
          <WifiOff className="h-4 w-4" />
          <span className="text-sm font-medium">Connection Lost</span>
        </motion.div>
      )}
    </AnimatePresence>
  );
}